/**
 * Sprint 11+12 — ThemeProvider.
 * Mount-time hook ensures the dark class lands on <html> before any page
 * renders; downstream code calls `useTheme()` directly for state + setters.
 */
import { useEffect, type ReactNode } from 'react'
import { applyTheme, getSystemPrefersDark, resolveIsDark } from '@/hooks/useDarkMode'
import { useUIStore } from '@/stores/ui'

export function ThemeProvider({ children }: { children: ReactNode }) {
  const theme = useUIStore((s) => s.theme)

  useEffect(() => {
    applyTheme(resolveIsDark(theme, getSystemPrefersDark()))
  }, [theme])

  return <>{children}</>
}
